import {
  GET_CATEGORIES,
  GET_CATEGORIES_ERROR,
  ADD_CATEGORY,
  ADD_CATEGORY_ERROR,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_ERROR,
  DELETE_CATEGORY,
  DELETE_CATEGORY_ERROR,
  GET_ACTIVE_CATEGORIES,
  GET_ACTIVE_CATEGORIES_ERROR,
  RESET_STORE,
  MANUALLY_TRIGGER_MESSAGE
} from "../types";

import { AddCategoryProps } from "../../types/actions/category";

import * as api from "../../api/axiosBase";

export const getCategories = () => async (dispatch) => {
  try {
    const { data } = await api.getCategories();
    dispatch({ type: GET_CATEGORIES, payload: data.data });
    dispatch({ type: GET_CATEGORIES_ERROR, payload: "" });
  } catch (error) {
    //dispatch({ type: LOGIN, payload: error.response.data.status });
    // dispatch({ type: LOGIN_ERROR, payload: error.response.data.message });
  }
};

export const getActiveCategories = () => async (dispatch) => {
  try {
    const { data } = await api.getActiveCategories();
    dispatch({ type: GET_ACTIVE_CATEGORIES, payload: data.data });
    dispatch({ type: GET_ACTIVE_CATEGORIES_ERROR, payload: "" });
  } catch (error) {
    //     dispatch({ type: LOGIN, payload: error.response.data.status });
    // dispatch({ type: LOGIN_ERROR, payload: error.response.data.message });
  }
};

export const addCategory =
  (formData: any, history: any) => async (dispatch) => {
    try {
      const { data } = await api.addCategory(formData);
      dispatch({ type: ADD_CATEGORY, payload: data.status });
      dispatch({ type: ADD_CATEGORY_ERROR, payload: "" });
      dispatch(getActiveCategories());
      //history.push("/categories");
    } catch (error) {
      dispatch({
        type: ADD_CATEGORY_ERROR,
        payload: error.response.data.message
      });
      dispatch({ type: ADD_CATEGORY, payload: error.response.data.status });
    }
  };

export const updateCategory =
  (formData: AddCategoryProps, id: string) => async (dispatch) => {
    try {
      const { data } = await api.updateCategory(id, formData);
      dispatch({ type: UPDATE_CATEGORY, payload: data.status });
      dispatch({ type: UPDATE_CATEGORY_ERROR, payload: "" });
      dispatch(getActiveCategories());
      //history.push("/categories");
    } catch (error) {
      dispatch({
        type: UPDATE_CATEGORY_ERROR,
        payload: error.response.data.message
      });
      dispatch({ type: UPDATE_CATEGORY, payload: error.response.data.status });
    }
  };

export const deleteCategory = (id) => async (dispatch) => {
  try {
    const res = await api.deleteCategory(id);
    dispatch(getCategories());
    dispatch({
      type: DELETE_CATEGORY,
      payload: id
    });
  } catch (e) {
    dispatch({
      type: DELETE_CATEGORY_ERROR,
      payload: e
    });
  }
};

export const manuallyTrigerMessage = (message: string) => (dispatch) => {
  dispatch({ type: MANUALLY_TRIGGER_MESSAGE, payload: message });
};

export const resetStore = () => (dispatch) => {
  dispatch({ type: RESET_STORE, payload: [] });
};
